var _rect, _rect2, _rect3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReelMask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 339,
    viewBox: "0 0 195 339",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 194,
    height: 43,
    fill: "black",
    fillOpacity: 0.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 296,
    width: 194,
    height: 43,
    fill: "black",
    fillOpacity: 0.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 43,
    width: 194,
    height: 253,
    stroke: "#FAFAFA"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReelMask);
export default __webpack_public_path__ + "static/media/reelMask.5dcc948b.svg";
export { ForwardRef as ReactComponent };